import { combineReducers } from 'redux';
import currentUser from './userState';
import notificationState from './notificationState';
import peopleState from './peopleState';
import taskOperation from './taskState';
import dateRangeState from './minMaxDateRangePickerState';
import leaveTabState from './leaveTabState';
import filterState from './filter/filterState';
import filterConfigState from './filter/filterConfigState';
import cardState from './cardState/cardState';
import timingsReportColumnFilterState from './timingsReportColumnFilterState';
import selectedMonthRangeState from './selectedMonthRangeState';

export default combineReducers({
  currentUser,
  notificationState,
  peopleState,
  taskOperation,
  dateRangeState,
  selectedMonthRangeState,
  leaveTabState,
  filterState,
  filterConfigState,
  cardState,
  timingsReportColumnFilterState,
});
